const indexItems = [
  { title: '明星塌房实录', desc: '盘点近年翻车艺人全记录，从顶流到十八线的塌房时间线完整梳理。', icon: 'ri-user-unfollow-line', size: 'large' },
  { title: '网红翻车现场', desc: '千万级网红带货翻车、人设崩坏、黑历史被扒的完整合集与深度分析。', icon: 'ri-live-line', size: 'large' },
  { title: '综艺节目黑幕', desc: '选秀投票造假、真人秀剧本泄露、综艺剪辑恶意引导等内幕大起底。', icon: 'ri-tv-line', size: 'normal' },
  { title: '娱乐圈金钱链', desc: '片酬虚高、阴阳合同、洗钱通道，娱乐圈灰色收入产业链全解析。', icon: 'ri-money-dollar-circle-line', size: 'normal' },
  { title: '饭圈乱象曝光', desc: '粉丝集资跑路、站姐诈骗、数据造假，饭圈经济背后的隐秘江湖。', icon: 'ri-group-line', size: 'normal' },
  { title: '剧组内幕揭秘', desc: '片场霸凌、潜规则、替身滥用的真实爆料，揭开光鲜背后的阴暗面。', icon: 'ri-clapperboard-line', size: 'normal' },
  { title: '音乐圈假唱档案', desc: '历年大型晚会、演唱会假唱实锤合集，从对口型到半开麦全收录。', icon: 'ri-music-line', size: 'normal' },
  { title: '品牌代言翻车', desc: '明星代言产品暴雷、虚假宣传被罚，品牌与艺人谁在欺骗消费者。', icon: 'ri-shopping-bag-line', size: 'normal' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10">
          📂 专题索引
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {indexItems.map((item, idx) => {
            const isLarge = idx < 2;
            const colSpan = isLarge ? 'lg:col-span-1' : '';
            return (
              <div
                key={idx}
                className={`group bg-background-100 rounded-xl p-6 md:p-7 cursor-pointer hover:bg-primary-50/30 transition-colors border border-background-200/60 ${colSpan}`}
              >
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${item.icon} text-xl text-primary-600 w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-1 text-primary-500 text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                  进入专题
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}